import { F33Crud } from "./f33.model";
import { Region } from "shared-lib";
import { SubstationCrud } from "shared-lib";
import { TransmissionStation } from "shared-lib";

export class Feeder11Dto {
    id: number;
    name: string;

    constructor(id: number, name: string){
        this.id = id;
        this.name = name
    }
}

export class F11CrudCreate {
    id: number;
    name: string;
    number: string;
    substationId?: number | null;
    transmissionStationId?: number | null;
    feeder33Id?: number | null;
    nameplateRating: string;
    regionId: number;
    utilityId: number;
}

export class F11Crud {
    id: number;
    name: string;
    number: string;
    transmissionStation?: TransmissionStation;
    transmissionStationId?: number;
    substation?: SubstationCrud;
    substationId?: number;
    feeder33?: F33Crud;
    feeder33Id?: number;
    region?: Region;
    nameplateRating: string;
    utilityId: number;
    guid: string;
    code: string;
}

export interface Feeder11 {
    id: number;
    name: string;
    number: string;
    substation?: string;
    transmissionStation?: string;
}